import axios from "axios";
import instance from "../../../../axios";

export const BASEV2_URL = `${process.env.REACT_APP_API_URL_V2}`;
export const BASE_URL = `${process.env.REACT_APP_API_URL}`;
export const LOCAL_URL = `${process.env.REACT_APP_API_URL_LOCAL}`;

export function getAdsLogListList(queryParams, coinStoresForEdit) {
  const headers = {
    "company-id": coinStoresForEdit?.item?._id,
  };

  const URLId = localStorage.getItem("URLID");
  return instance
    .post(
      `${BASEV2_URL}/adDownload/getLogs/${URLId}`,
      {
        pagination: {
          pageNo: parseInt(queryParams.page) ? parseInt(queryParams.page) : 1,
          recordPerPage: parseInt(queryParams.limit)
            ? parseInt(queryParams.limit)
            : 10,
          sortBy: queryParams.sortBy,
          sortDirection: queryParams.sort,
        },
        search: queryParams?.search,
      },
      { headers }
    )
    .then((res) => {
      return res;
    });
}

export function getCompany(queryParams) {
  return instance
    .post(`${BASE_URL}/country/dropdown/list`, queryParams)
    .then((res) => {
      return res;
    });
}

export function getcurrency(queryParams) {
  return instance
    .post(`${BASE_URL}/currency/dropdown/list`, queryParams)
    .then((res) => {
      return res;
    });
}

export function fetchCountriesList(queryParams) {
  return instance.post(`${BASE_URL}/country/list`, queryParams).then((res) => {
    return res;
  });
}

export function fetchCountriesDropdownList(queryParams) {
  return instance
    .post(`${BASE_URL}/country/Dropdown/list`, queryParams)
    .then((res) => {
      return res;
    });
}
